import { createSvgComponent } from "../../icon/createSvgComponent";
import CircleClock from "@core/icon/assets/circle-clock.svg";
export default createSvgComponent(CircleClock);